<template lang="pug">
  div.garbage.defense-update
    e-form-modal(
      ref="modalForm"
      @submitModalForm="sendForm()"
      :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
        v-model="tabView"
        :tabs="[{tab1: 'Общие сведения'},{tab2: 'Населенные пункты'}]"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView == 'tab1'")
            div.body
              div.col
                e-form-group(
                name="okato"
                inputType="input"
                validationRule="number"
                label="ОКАТО"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="oktmo"
                inputType="input"
                validationRule="number"
                label="OKTMO"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="area"
                inputType="input"
                validationRule="double"
                label="Площадь, га"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="tko_operator_id"
                inputType="select"
                label="Региональный оператор"
                  optionValueKey="id"
                  optionTextKey="name"
                  :required="true"
                  :model="fields"
                    :options="regionalOperators"
                placeholder="Укажите оператора"
                tabView="tab1"
                )

              div.col
                e-form-subtitle(text="Численность населения, чел.")

                e-form-group(
                name="year"
                inputType="select"
                :options="years"
                label="Год"
                :model="currentResidentYear"
                @change="setCurrentResidents()"
                tabView="tab1"
                )
                e-form-group(
                name="apartment_building_residence"
                inputType="input"
                label="Численность в МКД, чел"
                  :model="currentResidents"
                tabView="tab1"
                  validationRule="number"
                :onChangeValidation="true"
                )
                e-form-group(
                name="private_house_residence"
                inputType="input"
                label="Численность в ИЖД, чел"
                  :model="currentResidents"
                tabView="tab1"
                validationRule="number"
                  :onChangeValidation="true"
                )
                e-form-group(
                name="total"
                inputType="input"
                label="Итого:"
                  :disabled="true"
                  :model="currentResidents"
                tabView="tab1"
                )

              div.col
                div.col-block


          // вкладка НАСЕЛЕННЫЕ ПУНКТЫ
          div(v-show="tabView == 'tab2'")
                    div.body.body-table
                      div.table-choose-panel
                        div.toolbar-table
                          div.select.list Населенные пункты
                            //div.actions-panel
                              button.actions-panel__button.btn-delete
                              button.actions-panel__button.btn-add.green

                        e-table-inner(
                          tableWrapperClass="table"
                          class="table--half"
                          :visibleColumns="localityVisibleColumns"
                          :itemsEndpoint="endpointLocalityList"
                          @deleteItem="deleteLocality($event)"
                          :enableInnerPagination="false"
                        :showRemoveConfirmation="false"
                        ref="localityTable"
                        )
</template>

<script>
  import {atu, tko} from '../../../api/api-endpoints.js'
  import objectForm from '../mixins/object-form.js'

  export default {
    mixins: [objectForm],
    data () {
      return {
        tabView: 'tab1',
        fields: {},

        errors: null
      }
    },
    methods: {
      getRegionalOperatorEndpoint () {
        return tko.regionalOperators({query: {'per-page': -1}})
      },
      getUpdateOrCreateUrl () {
        return atu.atuObjectUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return atu.atuObject(route.params.id)
      }
    }
  }
</script>
